import io from 'socket.io-client';

const webSocketServer = 'https://business-client-connection.herokuapp.com';

const socket = io( webSocketServer );

export default socket;